// extracted by mini-css-extract-plugin
module.exports = {"calendarContainer":"ClockData_calendarContainer__3g2Rd","calendarButtons":"ClockData_calendarButtons__J_-DS"};